import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const Container = styled.div`
    background: ${(props) => promoColors[props.bgColor]};
    overflow: hidden;
    padding-top: ${(props) => (props.doubleTopPadding ? '64px' : props.noTopPadding ? '0' : props.hasBorderRadius ? '56px' : '32px')};
    padding-bottom: ${(props) => (props.bottomPadding ? '32px' : null)};
    border-radius: ${(props) => (props.hasBorderRadius ? '24px 24px 0 0' : null)};
    margin-top: ${(props) => (props.hasBorderRadius ? '-24px' : null)};
    position: relative;

    ${promoMedia.tablet744} {
        padding-top: ${(props) => (props.doubleTopPadding ? '96px' : props.noTopPadding ? '0' : props.hasBorderRadius ? '72px' : '48px')};
        padding-bottom: ${(props) => (props.bottomPadding ? '48px' : null)};
    }

    ${promoMedia.desktop1440} {
        padding-top: ${(props) => (props.doubleTopPadding ? '128px' : props.noTopPadding ? '0' : props.hasBorderRadius ? '88px' : '64px')};
        padding-bottom: ${(props) => (props.bottomPadding ? '64px' : null)};
    }
`;

const ColoredSectionContainer = (props) => {
    return (
        <Container
            bgColor={props.bgColor}
            doubleTopPadding={props.doubleTopPadding}
            noTopPadding={props.noTopPadding}
            bottomPadding={props.bottomPadding}
            hasBorderRadius={props.hasBorderRadius}
        >
            <PromoSectionContainer dimension={props.dimension}>{props.children}</PromoSectionContainer>
        </Container>
    );
};

ColoredSectionContainer.propTypes = {
    bgColor: PropTypes.oneOf(['baseColor', 'white', 'purple5', 'gray5', 'aubergine01', 'eggshell01', 'eggshell02', 'eggshell03', 'transparent']),
    doubleTopPadding: PropTypes.bool,
    noTopPadding: PropTypes.bool,
    bottomPadding: PropTypes.bool,
    dimension: PropTypes.oneOf(['wide', 'narrow', 'average']),
    hasBorderRadius: PropTypes.bool,
};

export default ColoredSectionContainer;
